import { GroupHierarchy, GroupMapping } from '@/models/groups/hierarchy';
import permission from '@/permission/permission';
import { hierarchy } from 'd3';


class GroupsSerializer {
    public static instance = new GroupsSerializer();

    /**
     * @function serializeUserHierarchies
     * @param payload
     * @returns {GroupHierarchy[]}
     * Method to serializer groups hierarchies data
     */
    public getLoggedTenantId () {
        return permission.getTenantId();
    }
    public serializeUserHierarchies(payload: any): GroupHierarchy[] {
        const serializedGroupsHierarchies: GroupHierarchy[] = [];
        if (payload && payload.hierarchies) {
            const groupHierarchies = payload.hierarchies || [];
            groupHierarchies.map((groupHierarchy: any) => {
                const serializedGroupsHierarchy: GroupHierarchy = {
                    id: groupHierarchy.id,
                    name: groupHierarchy.name,
                    description: groupHierarchy.description,
                    tenants: groupHierarchy.tenants,
                    levels: groupHierarchy.levels,
                };
                serializedGroupsHierarchies.push(serializedGroupsHierarchy);
            });
        }
        const tenantId = this.getLoggedTenantId();
        const serializedGroupsHierarchiesFiltered = serializedGroupsHierarchies.filter ((hierarchy:any)=>hierarchy.tenants.some((tenant:any)=> tenant.id == tenantId));
        return serializedGroupsHierarchiesFiltered;
    }

    public serializeMappingData(payload: any) {
        const serializedGroupsMapping: GroupMapping[] = [];
        const results = payload && payload.results &&  payload.results.length > 0 ? payload.results : [];
        if (results &&  results.length > 0) {
            results.map((groupHierarchy: any) => {
                const serializedGroupsMap: GroupMapping = {
                    id: groupHierarchy.group.id,
                    name: groupHierarchy.group.name,
                    description: groupHierarchy.group.description,
                    code: groupHierarchy.group.code,
                    parentId: groupHierarchy.group.parent_id,
                    reference_id: groupHierarchy.group.reference_id,
                    type: groupHierarchy.group.type,
                };
                serializedGroupsMapping.push(serializedGroupsMap);
            });
        }
        return serializedGroupsMapping;
    }

    public serializeGroupedHierarchyMapping(payload: any) {
        const serializedGroupsMapping: GroupMapping[] = [];
        const results = payload && payload.results && payload.results.length > 0 ? payload.results : [];
        for (const groupHierarchy of results) {
            const serializedGroupsMap: GroupMapping = {
                id: groupHierarchy.id,
                name: groupHierarchy.name,
                description: groupHierarchy.description,
                code: groupHierarchy.code,
                parentId: groupHierarchy.parent_id,
                reference_id: groupHierarchy.reference_id,
                type: groupHierarchy.type,
            };
            serializedGroupsMapping.push(serializedGroupsMap);
        }
        const emptyList = serializedGroupsMapping.reduce((r: any, a: any) => {
            r[a.parentId] = r[a.parentId] || { selectedCohort: [], cohortList: [] };
            r[a.parentId].cohortList.push(a);
            return r;
        }, Object.create(null));
        return emptyList;
    }

}

export const groupsSerializer = GroupsSerializer.instance;
